export type PeopleSearchRequest = {
  orgId: number;
  search: string;
  onlyActive?: boolean;
  type?: string;
  userRoleBlacklist?: number[];
  useRoleBasedSearch?: boolean;
};

export type PeopleSearchSuccessResponseSchemaContract = {
  label: string;
  key: number;
  title: null | string;
  role: null | string;
}[];

export const PeopleSearchSuccessResponseSchema = {
  type: 'array',
  items: {
    type: ['object'],
    properties: {
      key: { type: 'number' },
      label: { type: 'string' },
      title: { type: ['null', 'string'] },
      role: { type: ['null', 'string'] },
    },
    required: ['key', 'label'],
  },
};

export type SaveUserUiPreferenceRequestData = {
  [key: string]: any;
};
